import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../Utilities/Modal";
import {useState} from "react";
import ApiRoute from "../../../helper/api";
import ShopSelect from "../../Shop/ShopSelect";
import ProductSelect2 from "../../Product/ProductSelect2";

export default function ProductCloneModal({product, closeModal, event}) {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: product.title,
        shop: null,
        parent_id: null
    });

    async function handleClone() {
        if (!formData.shop) {
            return;
        }
        
        setLoading(true);
        try {
            await ApiRoute.product.clone.fn(product._id, {
                title: formData.title,
                shop_id: formData.shop,
                parent_id: formData.parent_id?._id
            });
            event();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Modal isOpen={true} onClose={closeModal}>
            <div className="p-4">
                <div className="flex items-center mb-4">
                    <FontAwesomeIcon icon={faCopy} className="text-purple-2 text-xl ml-2"/>
                    <h3 className="text-lg font-medium">کلون محصول</h3>
                </div>
                
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            عنوان محصول
                        </label>
                        <input
                            type="text"
                            value={formData.title}
                            onChange={(e) => setFormData(prev => ({...prev, title: e.target.value}))}
                            className="input-x w-full"
                            placeholder="عنوان محصول"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            فروشگاه
                        </label>
                        <ShopSelect
                            hasFrontEnd={true}
                            multiple={false}
                            assignItem={(shop) => setFormData(prev => ({...prev, shop: shop._id}))}
                            placeholder="انتخاب فروشگاه"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            محصول والد
                        </label>
                        <ProductSelect2
                            onChange={(parent_id) => setFormData(prev => ({...prev, parent_id: parent_id._id}))}
                            placeholder="انتخاب محصول والد"
                            allowOutStock={true}
                            isMulti={false}
                            isClearable={true}
                            isSearchable={true}
                        />
                    </div>
                </div>
                
                <div className="flex justify-end gap-2 mt-6">
                    <button 
                        onClick={closeModal}
                        className="px-4 py-2 text-gray-600 hover:text-gray-800"
                    >
                        انصراف
                    </button>
                    <button
                        onClick={handleClone}
                        disabled={loading || !formData.shop}
                        className="px-4 py-2 bg-purple-2 text-white rounded hover:bg-purple-1 disabled:opacity-50"
                    >
                        {loading ? 'در حال انجام...' : 'تایید'}
                    </button>
                </div>
            </div>
        </Modal>
    );
} 